<template>
  <div>
    <Head title="Energy Statistics - LEP1 Generation Capacity" />
    <section class="mt-2">
      <div class="flex flex-wrap items-center justify-between mb-4 gap-3">
        <div>
        <span class="group flex items-center py-3 mb-6">
          <icon name="issues" class="mr-4 w-8 h-8 text-gray-700"/>
          <h1 class="text-3xl font-bold">Senarai Penjanaan Kapasiti LEP1</h1>
        </span> 
        </div>
        <button type="button" class="px-4 py-2 rounded bg-indigo-600 text-white disabled:opacity-50" :disabled="metabaseLoading" @click="loadMetabase">
          {{ metabaseLoading ? 'Loading...' : 'Refresh Data' }}
        </button>
      </div>
      <div v-if="metabaseError" class="p-4 mb-4 bg-red-100 text-red-800 rounded" role="alert">{{ metabaseError }}</div>
      <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
        <input v-model.trim="metabaseSearch" type="search" placeholder="Search Metabase records..." aria-label="Search Metabase records" class="form-input w-full max-w-md" />
        <span class="text-sm text-gray-600">{{ filteredMetabaseRows.length.toLocaleString() }} of {{ metabaseRows.length.toLocaleString() }} records</span>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap text-sm">
          <thead>
            <tr class="text-left bg-gray-100">
              <th v-for="column in metabaseColumns" :key="column" class="px-4 py-3 font-bold">{{ column }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, index) in paginatedMetabaseRows" :key="metabasePage + '-' + index" class="hover:bg-gray-50">
              <td v-for="column in metabaseColumns" :key="column" class="border-t px-4 py-3">{{ record[column] == null ? '' : record[column] }}</td>
            </tr>
            <tr v-if="!metabaseLoading && paginatedMetabaseRows.length === 0">
              <td :colspan="metabaseColumns.length || 1" class="px-4 py-6 text-center text-gray-500">No records found.</td>
            </tr>
            <tr v-if="metabaseLoading">
              <td :colspan="metabaseColumns.length || 1" class="px-4 py-6 text-center text-gray-500">Loading Metabase records...</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex flex-wrap items-center justify-between mt-4 gap-3">
        <span class="text-sm text-gray-600">Page {{ metabasePage }} of {{ metabaseTotalPages }}</span>
        <div class="flex gap-2">
          <button type="button" class="px-3 py-2 border rounded disabled:opacity-40" :disabled="metabasePage <= 1" @click="metabasePage--">Previous</button>
          <button type="button" class="px-3 py-2 border rounded disabled:opacity-40" :disabled="metabasePage >= metabaseTotalPages" @click="metabasePage++">Next</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'

export default {
  components: { Head,Icon },
  layout: Layout,
  data() {
    return {
      metabaseRows: [],
      metabaseColumns: [],
      metabaseLoading: false,
      metabaseError: null,
      metabaseSearch: '',
      metabasePage: 1,
      metabasePageSize: 25,
    }
  },
  computed: {
    filteredMetabaseRows() {
      const search = this.metabaseSearch.toLocaleLowerCase()
      if (!search) return this.metabaseRows
      return this.metabaseRows.filter(record =>
        this.metabaseColumns.some(column =>
          String(record[column] == null ? '' : record[column]).toLocaleLowerCase().includes(search)
        )
      )
    },
    metabaseTotalPages() {
      return Math.max(1, Math.ceil(this.filteredMetabaseRows.length / this.metabasePageSize))
    },
    paginatedMetabaseRows() {
      const start = (this.metabasePage - 1) * this.metabasePageSize
      return this.filteredMetabaseRows.slice(start, start + this.metabasePageSize)
    },
  },
  watch: {
    metabaseSearch() { this.metabasePage = 1 },
  },
  mounted() {
    this.loadMetabase()
  },
  methods: {
    async loadMetabase() {
      this.metabaseLoading = true
      this.metabaseError = null
      try {
        const response = await fetch('/estat/metabase-data', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
        if (!response.ok) throw new Error('HTTP ' + response.status)
        const payload = await response.json()
        if (!payload.success || !Array.isArray(payload.data)) {
          throw new Error('Unexpected Metabase response')
        }
        this.metabaseRows = payload.data
        this.metabaseColumns = payload.data.length ? Object.keys(payload.data[0]) : []
        this.metabasePage = 1
      } catch (error) {
        this.metabaseError = 'Unable to load Metabase data: ' + error.message
      } finally {
        this.metabaseLoading = false
      }
    },
  },
}
</script>